exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".inputPlaceholder__LoadingFilters-module___1UeI2 {\n  width: 100%;\n  height: 38px;\n  background-color: #8a96a1;\n  animation: placeholder-glow__LoadingFilters-module___2l5xx 2s ease-in-out infinite;\n}\n\n\n@keyframes placeholder-glow__LoadingFilters-module___2l5xx {\n  0% {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n  50% {\n    background-color: rgba(0, 0, 0, 0.3);\n  }\n  100% {\n    background-color: rgba(0, 0, 0, 0.1);\n  }\n}\n", ""]);

// Exports
exports.locals = {
	"inputPlaceholder": "inputPlaceholder__LoadingFilters-module___1UeI2",
	"placeholder-glow": "placeholder-glow__LoadingFilters-module___2l5xx"
};